import React from "react";
import ModalSelecionar from "./ModalSelecionar";

const COLUNAS = [
  { header: "Código", render: (im) => im.codigoMatricula || "—" },
  { header: "Apelido", render: (im) => im.apelido || "—", destaque: true },
  { header: "Endereço", render: (im) => [im.endereco, im.numero].filter(Boolean).join(", ") || "—", maxWidth: 180 },
  { header: "Bairro", render: (im) => im.bairro || "—" },
  { header: "Cidade/UF", render: (im) => [im.cidade, im.uf].filter(Boolean).join("/") || "—" },
  { header: "Status", render: (im) => im.status || "—" },
];

export default function ModalSelecionarImovel(props) {
  return (
    <ModalSelecionar
      titulo="Selecionar Imóvel"
      endpoint="/api/imoveis/selecao"
      placeholder="Código, apelido, endereço, bairro ou cidade…"
      colunas={COLUNAS}
      {...props}
    />
  );
}
